<lib-dialog
  [title]="
    'lib_calendar.appointment-cancellation-dialog.text.title' | translate
  "
  [isLoading]="isLoading"
  (closeButtonClick)="closeDialog()"
>
  <div *ngIf="isAdvanceCancellation()" header>
    <lib-spacer [height]="10"></lib-spacer>
    <lib-simple-step-process
      [totalSteps]="2"
      [numberOfFinishedSteps]="step"
    ></lib-simple-step-process>
  </div>

  <div body>
    @if (!isAdvanceCancellation() || step === 1) {
    <div>
      {{
        'lib_calendar.appointment-cancellation-dialog.text.description'
          | translate
      }}
    </div>
    <lib-spacer></lib-spacer>
    } @if(isAdvanceCancellation()) { @if(step === 1) {
    <mat-radio-group
      class="radio-group"
      [formControl]="cancellationCaseControl"
    >
      <mat-radio-button color="primary" [value]="CANCELLATION_CASE.NO_SHOW">
        {{
          'lib_calendar.appointment-cancellation-dialog.text.no_show'
            | translate
        }}
      </mat-radio-button>
      <mat-radio-button color="primary" [value]="CANCELLATION_CASE.OTHERS">{{
        'lib_calendar.appointment-cancellation-dialog.text.reason-other'
          | translate
      }}</mat-radio-button>
    </mat-radio-group>
    } @else { @if (isNoShowCase()) {
    <div>
      <ng-container *ngIf="!numberOfNoShowAppointment">
        {{
          'lib_calendar.appointment-cancellation-dialog.text.not_show_up_first_time'
            | translate
        }}
      </ng-container>
      <ng-container *ngIf="numberOfNoShowAppointment > 0">
        {{
          'lib_calendar.appointment-cancellation-dialog.text.not_show_up'
            | translate : { total: numberOfNoShowAppointment }
        }}
      </ng-container>
    </div>

    <lib-spacer></lib-spacer>

    <lib-slide-toggle-container
      [isOn]="blockCustomerControl.value"
      [flexLeft]="'70%'"
      [flexRight]="'30%'"
      [textOn]="'lib_calendar.appointment-cancellation-dialog.text.yes'"
      [textOff]="'lib_calendar.appointment-cancellation-dialog.text.no'"
      [title]="
        'lib_calendar.appointment-cancellation-dialog.text.block_customer'
      "
    >
      <mat-slide-toggle
        [formControl]="blockCustomerControl"
        color="primary"
      ></mat-slide-toggle>
    </lib-slide-toggle-container>
    } @else {
    <mat-form-field>
      <mat-label>{{
        'lib_calendar.appointment-cancellation-dialog.text.message_to_customer'
          | translate
      }}</mat-label>
      <textarea
        [formControl]="cancelReasonControl"
        matInput
        cdkTextareaAutosize
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="5"
      ></textarea>
    </mat-form-field>
    } } } @else {
    <mat-form-field>
      <mat-label>{{
        'lib_calendar.appointment-cancellation-dialog.text.reason' | translate
      }}</mat-label>
      <mat-select [formControl]="cancelReasonControl">
        <mat-option
          *ngFor="let reason of CANCEL_REASONS"
          [value]="
            'lib_calendar.appointment-cancellation-dialog.text.' + reason
              | translate
          "
        >
          {{
            'lib_calendar.appointment-cancellation-dialog.text.' + reason
              | translate
          }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    }
  </div>

  <ng-container action>
    @if(isAdvanceCancellation()) { @if(step === 1) {
    <button mat-stroked-button (click)="closeDialog(false)">
      {{
        'lib_calendar.appointment-cancellation-dialog.buttons.close' | translate
      }}
    </button>
    <button (click)="nextStep()" mat-flat-button color="primary">
      {{
        'lib_calendar.appointment-cancellation-dialog.buttons.next' | translate
      }}
    </button>
    } @else {
    <button mat-stroked-button (click)="previousStep()">
      {{
        'lib_calendar.appointment-cancellation-dialog.buttons.back' | translate
      }}
    </button>
    <ng-container
      [ngTemplateOutlet]="appointmentCancellationButtonTemplate"
    ></ng-container>
    } } @else {
    <lib-spacer></lib-spacer>
    <ng-container
      [ngTemplateOutlet]="appointmentCancellationButtonTemplate"
    ></ng-container>
    <lib-spacer></lib-spacer>
    }
  </ng-container>
</lib-dialog>

<ng-template #appointmentCancellationButtonTemplate>
  <button
    mat-flat-button
    color="warn"
    [disabled]="!isAbleToCancelAppointment()"
    (click)="cancelAppointment()"
  >
    {{
      'lib_calendar.appointment-cancellation-dialog.buttons.cancel' | translate
    }}
  </button>
</ng-template>
